import styled from 'styled-components'

const BASIC = 'basic'

const Style = {
	AdDiv: styled.div`
		flex-grow: 1;
		min-height: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background-color: ${({$themeType, theme}) =>
			$themeType === BASIC ? '#ffffff' : '#1a202c'};
	`,
	SrcDiv: styled.div`
		width: 101%;
		flex-grow: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		& > p {
			font-size: 32px;
			color: ${({$themeType, theme}) =>
				$themeType === BASIC ? '#ffffff' : '#000000'};
		}

		& > img {
			height: 101%;
			object-fit: fill;
		}

		& > video {
			height: 101%;
			object-fit: fill;
		}
	`,
	// Reuse some styles if needed, or define specific ones
}

export default Style
